<div class="modern-circular-progress" [style.width.px]="size" [style.height.px]="size">
  <svg
    class="progress-ring"
    [attr.width]="size"
    [attr.height]="size"
    [attr.viewBox]="viewBox">

    <!-- Background circle -->
    <circle
      class="progress-ring__background"
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      [attr.stroke]="backgroundColor"
      [attr.stroke-width]="strokeWidth"
      fill="transparent">
    </circle>

    <!-- Progress circle -->
    <circle
      class="progress-ring__progress"
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      [attr.stroke]="color"
      [attr.stroke-width]="strokeWidth"
      [attr.stroke-dasharray]="strokeDasharray"
      [attr.stroke-dashoffset]="strokeDashoffset"
      [style.animation-duration.ms]="animationDuration"
      fill="transparent">
    </circle>
  </svg>

  <!-- Percentage text -->
  @if (showPercentage) {
    <div
      class="progress-text"
      [style.font-size.px]="fontSize">
      {{ value }}%
    </div>
  }
</div>
